import React, { Component } from "react";
import styled from "styled-components";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import MonthView from "../../../Shared/DateHeader/MonthView";
import ManagerOneDayView from "./ViewForOneDay";
import { CaretUp } from "styled-icons/boxicons-regular/CaretUp";

import {
  getMonthTimesheetData,
  fetchManagerHourAnalytics,
  fetchRecalculateHour,
  showModal,
  hideModal,
  resetAprroveMessage,
  resetsaveTimesheetMessage,
} from "../../../../Actions";
import { format, isFuture ,isToday} from "date-fns";
import { dateFormat } from "../../../../Api/Utils/ReuseableFunctions";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation, Trans } from "react-i18next";

class SingleTechnicianView extends Component {
  constructor(props) {
    super(props);

    this.payloadDay = {
      ssoId: props.match.params.techssoId,
      workshopLocation: props.branchId,
      action: "",
      date: "",
    };
    this.payloadMonth = {
      ssoId: props.match.params.techssoId,
      workshopLocation: props.branchId,
      role: "Technician",
      year: "",
      month: "",
      action: "",
    };
    this.state = {
      tab: "1",
      requestedDate: undefined,
      calenderDate: undefined,
      saveManagerCommentCreated: false,
      startDate:undefined,
      endDate:undefined,
      recalculaterefresh:undefined
    };
  }

  handleSelect = (data) => {
    this.setState({ tab: data });
    if (data === "2") {
      this.monthReponse();
    }
    if (data === "1") {
      this.dayResponse();
    }
  };

  dayResponse = (data) => {
    this.payloadDay.action = data ? data : "";
    this.payloadDay.date = this.state.requestedDate;
    this.props.dispatch(fetchManagerHourAnalytics(this.payloadDay));
  };

  recalculateResponse = (data) =>{
    this.payloadDay.action = data ? data : "";
    this.payloadDay.date = this.state.requestedDate;
    this.props.dispatch(fetchRecalculateHour(this.payloadDay));
    this.state.recalculaterefresh = true;
  };

  monthReponse = (data) => {
    this.payloadMonth.action = data ? data : "";
    this.payloadMonth.year = format(this.state.calenderDate, "yyyy");
    this.payloadMonth.month = format(this.state.calenderDate, "M");
    this.props.dispatch(getMonthTimesheetData(this.payloadMonth));
  };

  componentDidMount() {
    this.dayResponse();
  }

  openDayTimeModal = (data) => {
    data.dayData.ssoId = this.props.match.params.techssoId;
    data.breakCal = this.props.security.enableBreaksCal === "Y";
    data.showMintInt = this.props.security.showMintInt === "Y" || this.props.security.enableBreaksCal === "Y"
    let dataNew = JSON.stringify(data);
    if (!isFuture(data.dayVal) && !isToday(data.dayVal) ) {
      let modalProps = {
        open: true,
        data: JSON.parse(dataNew),
        closeModal: this.closeModal,
      };
      let template = "Technician/PopUp/EditTime/index";
      this.props.dispatch(showModal({ modalProps, template }));
    }
  };

  editData = () => {
    let data = {
      dayData: this.props.hourData.hoursDetail,
      dayVal: dateFormat(this.state.requestedDate),
      breakCal: this.props.security.enableBreaksCal === "Y",
      showMinInt: this.props.security.showMintInt === "Y" || this.props.security.enableBreaksCal === "Y",
    };
    // console.log(this.props.security.showMintInt === "Y" || this.props.security.enableBreaksCal === "Y")
    this.openDayTimeModal(data);
  };

  closeModal = (event) => {
    this.props.dispatch(hideModal());
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.hourData.requestedDate && prevState.requestedDate) {
      if (nextProps.hourData.requestedDate !== prevState.requestedDate) {
        return { requestedDate: nextProps.hourData.requestedDate };
      } else return null;
    } else if (nextProps.location.state && nextProps.location.state.date) {
      return {
        requestedDate:
          nextProps.location.state.date || format(new Date(), "dd/MM/yyyy"),
        calenderDate: dateFormat(nextProps.location.state.date) || new Date(),
      };
    } else return null;
  }

  redirectToHome() {
    this.props.history.push(
      "/timetracking/" + this.props.ssoId + "/manager/home"
    );
  }

  componentDidUpdate() {
    if (
      this.props.popUpMessage !== void 0 &&
      this.props.popUpMessage.type === "Timesheet Saved Successfully" &&
      this.props.popUpMessage.message.errorCd === "SUCCESS"
    ) {
      if (this.state.tab === "1") {
        // this.dayResponse();
        this.redirectToHome();
      }
      if (this.state.tab === "2") {
        this.monthReponse();
      }
      this.props.dispatch(resetsaveTimesheetMessage());
    }
    if (
      this.props.managerTimesheet &&
      this.props.managerTimesheet.errorCd === "SUCCESS"
    ) {
      if (this.state.tab === "1" && !this.state.saveManagerCommentCreated) {
        this.redirectToHome();
      } else if (this.state.tab === "1") {
        this.dayResponse();
      }
      this.props.dispatch(resetAprroveMessage());
    }
    if(this.props.recalculateData){
      if(this.state.recalculaterefresh){
      this.state.recalculaterefresh = false;
      this.dayResponse();
      }
    }
  }
  render() {
    const { security } = this.props
    const {startDate}=   this.props.location.state
    const {endDate}=   this.props.location.state
        return (
      <TabCont>
        <Tabs
          activeKey={this.state.activeTab}
          onSelect={(data) => this.handleSelect(data)}
        >
          <Tab
            eventKey={1}
            title={
              <>
                <Trans>hoursAnalytics</Trans>
                {this.state.tab === "1" && <CaretuP size="20" />}
              </>
            }
          >
            <ManagerOneDayView
              techssoID={this.props.match.params.techssoId}
              previousDay={() => this.dayResponse("prev")}
              nextDay={() => this.dayResponse("next")}
              sameDay={() => this.recalculateResponse()}
              editData={this.editData}
              startData={startDate}
              endData={endDate}
              saveManagerCommentCreated={(saveManagerCommentCreated) => {
                this.setState({ saveManagerCommentCreated });
              }}
            />{" "}
          </Tab>
          <Tab
            eventKey={2}
            title={
              <>
                <Trans>calendar</Trans>
                {this.state.tab === "2" && <CaretuP size="20" />}
              </>
            }
          >
            {this.state.tab === "2" && security && (
              <MonthView
                date={(date) => {
                  this.setState({ calenderDate: date });
                }}
                breakCal={this.props.security.enableBreaksCal === "Y"}
                openDayDetails={this.openDayTimeModal}
                techssoID={this.props.match.params.techssoId}
                previousMonth={() => this.monthReponse("prev")}
                nextMonth={() => this.monthReponse("next")}
                showMinInt={security.showMintInt === "Y" || security.enableBreaksCal === "Y"}
              />
            )}{" "}
            <label> </label>
          </Tab>
        </Tabs>
      </TabCont>
    );
  }
}

const mapStateToProps = ({
  auth,
  userMessage,
  hourAnalytics,
  recalculateHour,
  saveTechnicianTimesheet,
  approveWeekData,
  fetchTimesheetSecurity
}) => {
  return {
    isAuthenticated: auth.isAuthenticated,
    ssoId: auth.ssoId,
    message: userMessage,
    userDefault: auth.user.defaultProfile,
    branchId: auth.user.defaultProfile.branchId,
    hourData: hourAnalytics.payload,
    recalculateData: recalculateHour.message,
    popUpMessage: saveTechnicianTimesheet,
    managerTimesheet: approveWeekData.message,
    security: fetchTimesheetSecurity.securityList,
  };
};

export default withRouter(
  connect(mapStateToProps)(withTranslation()(SingleTechnicianView))
);

const CaretuP = styled(CaretUp)`
  position: absolute;
  color: #00a6eb;
  bottom: -8px;
  left: 50%;
  margin-left: -10px;
`;
const TabCont = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  padding-bottom: 80px;
  font-family: Trebuchet MS;
  font-size: 16px;
  .nav {
    border-bottom: none;
    bottom: 4px;
    position: relative;
  }
  .tab-content {
    width: 100%;
    padding-top: 14px;
    flex: 1 1 auto;
  }
  .tab-pane {
    height: 100%;
  }
  .nav-tabs {
    box-shadow: 0 4px 2px -2px #80808040;
    height: 41px;
    padding-left: 6px;
  }
  .nav-tabs .nav-link {
    border: none;
    border-top-left-radius: 0px;
    border-top-right-radius: opx;
    color: #7e7e7e;
    position: relative;
    padding: 5px 20px;
  }
  .nav-tabs .nav-item.show .nav-link,
  .nav-tabs .nav-link.active {
    border-bottom: 2px solid #00a6eb;
    color: #495057;
    background: none;
  }
`;
